<template>
    <div class="box box-primary">
        <div class="box-header">
            <h4 class="box-title">
                <i class="fa fa-user"></i>
                Sales
            </h4>
            <!-- <div class="box-tools pull">
                <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-chevron-down"></i></button>
            </div> -->
        </div>
        <div class="box-body">
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Tanggal penjualan *</label>
                        <datepicker
                          v-model="form.sales_date"
                          :formatDate="'DD-MM-YYYY'"
                          :config="salesDatepickerConfig"
                          :disabled="form.id || !permission"/>
                    </div>
                      <div class="form-group" :class="{'has-error': !!form.errors.seller_type}">
                        <label>Sales Bagian *</label>
                        <select
                          class="form-control"
                          v-model="form.seller_type"
                          :disabled="form.id || !permission">
                            <option :value="null">-- PILIH SALES BAGIAN --</option>
                            <option :value="'internal'" >Internal</option>
                            <option :value="'eksternal'" >Eksternal</option>
                        </select>
                        <p class="help text-red" v-if="form.errors.seller_type"><i class="fa fa-info-circle"></i> Sales bagian wajib diisi</p>
                    </div>

                    <div class="form-group" :class="{'has-error': !!form.errors.user_id}" v-if="form.seller_type == 'internal'">
                        <label>Sales *</label>
                        <select
                          class="form-control"
                          v-model="form.user_id"
                          :disabled="form.id || !permission">
                            <option :value="null">-- PILIH SALES --</option>
                            <option v-for="s in sales" :value="s.user_id" :key="s.user_id">{{ s.name }} ({{ s.group }})</option>
                        </select>
                        <p class="help text-red" v-if="form.errors.user_id"><i class="fa fa-info-circle"></i> Sales wajib diisi</p>
                    </div>

                     <div class="form-group" :class="{'has-error': !!form.errors.agency_id}" v-if="form.seller_type == 'eksternal'">
                        <label>Agensi *</label>
                        <select
                          class="form-control"
                          v-model="form.agency_id"
                          :disabled="form.id || !permission">
                            <option :value="null">-- PILIH AGENSI --</option>
                            <option v-for="data in agency" :value="data.id" :key="data.id">{{ data.name }}</option>
                        </select>
                        <p class="help text-red" v-if="form.errors.agency_id"><i class="fa fa-info-circle"></i> Agensi wajib diisi</p>
                    </div>

                    <div class="form-group" :class="{'has-error': !!form.errors.media.type}" v-if="form.seller_type == 'internal' && form.user_id != null">
                        <label>Referensi *</label>
                        <div class="custom-control custom-radio">
                            <input
                              class="custom-control-input"
                              id="r5" type="radio"
                              :disabled="form.id || !permission"
                              v-model="form.media.type"
                              :value="'Media'"
                              name="customRadio2">
                            <label class="custom-control-label" for="r5">
                                Media
                            </label>
                        </div>
                        <div class="custom-control custom-radio">
                            <input
                              class="custom-control-input"
                              id="r6"
                              type="radio"
                              :disabled="form.id || !permission"
                              v-model="form.media.type"
                              :value="'Personal'"
                              name="customRadio2"
                            >
                            <label class="custom-control-label" for="r6">
                                Personal
                            </label>
                        </div>
                        <p class="help text-red" v-if="form.errors.media.type"><i class="fa fa-info-circle"></i> Sumber referensi wajib diisi</p>
                    </div>
                </div>
                <div class="col-md-6" v-if="form.media.type == 'Media' && isShow ">
                    <div class="form-group" :class="{'has-error': !!form.errors.media.name}">
                        <label>Nama media *</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="form.media.name"
                          :disabled="form.id || !permission"
                          placeholder="Masukkan nama media referensi">
                        <p class="help help-block" v-if="form.errors.media.name">Wajib diisi</p>
                    </div>
                </div>
                <div class="col-md-6" v-if="form.media.type == 'Personal' && isShow ">
                    <div class="form-group" :class="{'has-error': !!form.errors.media.name}">
                        <label>Nama lengkap *</label>
                        <input
                          type="text"
                          class="form-control alpha-numeric-other-char"
                          v-model="form.media.name"
                          :disabled="form.id || !permission">
                        <p class="help help-block" v-if="form.errors.media.name">Wajib diisi</p>
                    </div>
                    <div class="form-group" :class="{'has-error': !!form.errors.media.phone_number}">
                        <label>No Telepon/HP *</label>
                        <input
                          type="text"
                          class="form-control"
                          v-on:keydown="validateNumberOnly($event)"
                          v-model="form.media.phone_number"
                          :disabled="form.id || !permission"
                          maxlength="13">
                        <p class="help help-block" v-if="form.errors.media.phone_number">Wajib diisi minimal 6 karakter, maksimal 13 karakter</p>
                    </div>
                    <div class="form-group" :class="{'has-error': !!form.errors.media.bank_number}">
                        <label>No Rekening *</label>
                        <input
                          type="text"
                          class="form-control"
                          v-on:keydown="validateNumberOnly($event)"
                          v-model="form.media.bank_number"
                          :disabled="form.id || !permission">
                        <p class="help help-block" v-if="form.errors.media.bank_number">Wajib diisi</p>
                    </div>
                    <div class="form-group" :class="{'has-error': !!form.errors.media.bank_name}">
                        <label>Bank *</label>
                        <input
                          type="text"
                          class="form-control alpha-numeric-other-char"
                          v-model="form.media.bank_name"
                          :disabled="form.id || !permission">
                        <p class="help help-block" v-if="form.errors.media.bank_name">Wajib diisi</p>
                    </div>
                    <div class="form-group" :class="{'has-error': !!form.errors.media.bank_account_name}">
                        <label>A/N *</label>
                        <input
                          type="text"
                          class="form-control alpha-numeric-other-char"
                          v-model="form.media.bank_account_name"
                          :disabled="form.id || !permission">
                        <p class="help help-block" v-if="form.errors.media.bank_account_name">Wajib diisi</p>
                    </div>
                    <div class="row">
                        <div class="col-md-4" :class="{'has-error': !!form.errors.media.commission_percent}">
                            <label>(%) Komisi *</label>
                            <input
                              type="number"
                              step="0.01"
                              min="0"
                              max="100"
                              maxlength="3"
                              v-on:keydown="validateNumberOnly($event)"
                              class="form-control"
                              v-model="form.media.commission_percent"
                              :disabled="form.id || !permission">
                            <p class="help help-block" v-if="form.errors.media.commission_percent">Wajib diisi</p>
                        </div>
                        <div class="col-md-8" :class="{'has-error': !!form.errors.media.commission}">
                            <label>(Rp.) Komisi</label>
                            <currency-input
                              type="text"
                              class="form-control"
                              v-model="form.media.commission"
                              disabled/>
                            <p class="help help-block" v-if="form.errors.media.comission">Wajib diisi</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { timestampToDate, formatDateofInputDate } from '../../../../../function'

// const {console} = window
export default {
    name: 'booking-sales',
    props: ['form', 'sales', 'agency', 'permission'],
    data() {
        return {
            commission: 0,
            salesDatepickerConfig: {
                minDate: moment().add('days', -20).format('DD-MM-YYYY'),
                maxDate: moment().endOf('hour').format('DD-MM-YYYY'),
                locale: {
                    format: 'DD-MM-YYYY'
                }
            },
            isShow: true
        }
    },
    mounted() {
        var toDay = timestampToDate(new Date().getTime())
        if (this.form.sales_date) {
        // if(this.form.sales_date.split('-')[0].length == 4){
            this.form.sales_date = formatDate(this.form.sales_date, 'DD-MM-YYYY')
            // this.form.sales_date = timestampToDate(new Date(this.form.sales_date).getTime())
        }
        // console.dir(this.form.sales_date)
        // var tempDate = timestampToDate(new Date(this.form.sales_date).getTime())
        if (typeof this.form.sales_date == 'undefined') {
            this.form.sales_date = moment().format('DD-MM-YYYY')
        }

        if(this.form.seller_type == 'internal'){
            this.isShow = true
        }else{
            this.isShow = false
        }
        // console.log('errors', this.form.errors)
    },
    methods: {
        resetMedia(){
            let self = this
            this.form.media.name = null
            this.form.media.phone_number = null
            this.form.media.bank_number = null
            this.form.media.bank_name = null
            this.form.media.bank_account_name = null
            this.form.media.commission_percent = 0
            this.form.media.commission = 0
            setTimeout( function() {
                self.form.errors.media.name = false
                self.form.errors.media.phone_number = false
                self.form.errors.media.bank_number = false
                self.form.errors.media.bank_name = false
                self.form.errors.media.bank_account_name = false
                self.form.errors.media.commission_percent = false
                self.form.errors.media.comission = false
            }, 50);
        },
        validateNumberOnly ($event) {
            if ($event) {
                if ($.inArray($event.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
             // Allow: Ctrl+A, Command+A
                    ($event.keyCode === 65 && ($event.ctrlKey === true || $event.metaKey === true)) ||
                     // Allow: home, end, left, right, down, up
                    ($event.keyCode >= 35 && $event.keyCode <= 40)) {
                         // let it happen, don't do anything
                         return;
                }
                // Ensure that it is a number and stop the keypress
                if (($event.shiftKey || ($event.keyCode < 48 || $event.keyCode > 57)) && ($event.keyCode < 96 || $event.keyCode > 105)) {
                    $event.preventDefault();
                }
            }
        }
    },
    watch: {
        'form.media.type': {
            handler(nw, old) {
                this.resetMedia()
                if (old && nw != old) {
                    this.form.media.commission_percent = 0
                    this.form.media.comission = 0
                }

                this.form.errors.media.type = false
                if(!nw){
                    this.form.errors.media.type = true
                }
            }
        },
        'form.seller_type': {
            handler(nw, old) {
                this.isShow = true
                this.resetMedia()
                this.form.errors.seller_type = false
                this.form.errors.user_id = false
                this.form.errors.agency_id = false
                this.form.user_id = null
                this.form.agency_id = null
                if(nw == 'eksternal'){
                    this.isShow = false

                }else if(!nw || nw == "null"){
                    this.form.errors.seller_type = true
                }
            }
        },
        'form.user_id':{
            handler(val){
                this.form.errors.user_id = false
                this.form.errors.agency_id = false
                if(this.form.seller_type && !val){
                    this.form.errors.user_id = true
                }
            }

        },
        'form.agency_id' :{
            handler(val){
                this.form.errors.user_id = false
                this.form.errors.agency_id = false
                if(this.form.seller_type && !val){
                    this.form.errors.agency_id = true
                }
            }
        },
        'form.media.commission_percent': {
            deep: true,
            handler(val) {
                this.form.errors.media.commission_percent = false
                this.form.errors.media.commission = false

                try{
                    if(this.form.seller_type == 'internal' && this.form.media.type == 'Personal'){
                        if(!val){
                            this.form.errors.media.media.commission_percent = true
                        }
                    }
                }catch(e){

                }

                try {
                    if(val > 100){
                        this.form.media.commission_percent = 100
                        val = 100;
                    }
                    var com = (parseFloat(this.form.media.commission_percent)/100) * this.form.subtotal3
                    if (isNaN(com)) {
                        com = 0
                    }
                    this.form.media.commission = com.toFixed(0)
                } catch (e) {
                    this.form.media.commission = 0
                }

                this.form.media.comission = this.commission
            }
        },
        'form.media.name' : {
            handler(val){
                this.form.errors.media.name = false
                if(this.form.seller_type == 'internal'){
                    if(!val){
                        this.form.errors.media.name = true
                    }
                }
            }
        },
        'form.media.phone_number' : {
            handler(val){
                this.form.errors.media.phone_number = false
                if(this.form.seller_type == 'internal' && this.form.media.type == 'Personal'){
                    if(!val){
                        this.form.errors.media.phone_number = true
                    }else{
                        try {
                            let length = val.toString().length
                            if(length < 6 || length > 13){
                                this.form.errors.media.phone_number = true
                            }
                        } catch (e) {}
                    }

                }
            }
        },
        'form.media.bank_number' : {
            handler(val){
                this.form.errors.media.bank_number = false
                if(this.form.seller_type == 'internal' && this.form.media.type == 'Personal'){
                    if(!val){
                        this.form.errors.media.bank_number = true
                    }
                }
            }
        },
        'form.media.bank_name' : {
            handler(val){
                this.form.errors.media.bank_name = false
                if(this.form.seller_type == 'internal' && this.form.media.type == 'Personal'){
                    if(!val){
                        this.form.errors.media.bank_name = true
                    }
                }
            }
        },
        'form.media.bank_account_name' : {
            handler(val){
                this.form.errors.media.bank_account_name = false
                if(this.form.seller_type == 'internal' && this.form.media.type == 'Personal'){
                    if(!val){
                        this.form.errors.media.bank_account_name = true
                    }
                }
            }
        },
        'form.total': {
            deep: true,
            handler() {
              if(this.form.seller_type) {
                if(this.form.seller_type.toLowerCase() == 'internal') {
                  if(this.form.media.type) {
                    if(this.form.media.type.toLowerCase() == 'personal') {
                      try {
                          var com = (parseFloat(this.form.media.commission_percent)/100) * this.form.subtotal3
                          if (isNaN(com)) {
                              com = 0
                          }
                          this.commission = com
                      } catch (e) {
                          this.commission = 0
                      }

                      this.form.media.comission = this.commission.toFixed(0)
                    }
                  }
                }
              }
            }
        },
        'form.subtotal3' : {
            deep: true,
            handler() {
              if(this.form.seller_type){
                if(this.form.seller_type.toLowerCase() == 'internal') {
                  if(this.form.media.type) {
                    if(this.form.media.type.toLowerCase() == 'personal') {
                      try {
                          var com = (parseFloat(this.form.media.commission_percent)/100) * this.form.subtotal3
                          if (isNaN(com)) {
                              com = 0
                          }
                          this.commission = com
                      } catch (e) {
                          this.commission = 0
                      }

                      this.form.media.comission = this.commission.toFixed(0)
                    }
                  }
                }
              }
            }
        }
    }
}
</script>
